export const fmtPhone = (p) => {
  const d = (p || "").replace(/\D/g, "").replace(/^90/, "");
  return d.length === 10 ? `0${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 8)} ${d.slice(8)}` : p;
};
export const waLink = (p) => `https://wa.me/${(p || "").replace(/\D/g, "")}`;
